module.exports = __webpack_public_path__ + "img/pa_directory_active.dae97cf3.svg";